import React from 'react';
import { useSelector } from 'react-redux';
import { productCodesSelectors } from '../../../common/config/store';
import StyledTable from '../../organisms/styled-table';
import ListModifier from '../../organisms/list-modifier';
import { useIntl } from '../../../common/config/i18n';
import { Empty } from 'antd';
import { ProductCode } from 'types';

type Props = {
  onClickDelete?: (productCode: object) => void;
  canWrite: boolean;
};

const ProductCodeTable: React.FC<Props> = ({ onClickDelete, canWrite }: Props) => {
  const { t } = useIntl();
  const data = useSelector(productCodesSelectors.productCodesSelector);

  const columns = [
    {
      title: t('table', 'CHART_PRODUCT_CODE'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('table', 'COLUMN_DELETE'),
      key: 'modifier',
      shouldBeAdmin: true,
      render: (record: ProductCode) => (
        <ListModifier hideEditButton hideDeleteButton={!canWrite} onDelete={() => onClickDelete?.(record)} />
      ),
    },
  ];

  const calculatedColumns = canWrite ? columns : columns.filter((column) => !column.shouldBeAdmin);

  return (
    <StyledTable
      rowKey="id"
      textAlign="left"
      pagination={false}
      dataSource={data}
      columns={calculatedColumns}
      locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('empty')} /> }}
    />
  );
};

export default ProductCodeTable;
